// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2123t","topBottomGutter":"Layout_topBottomGutter__2qkTr"};